import React, { useEffect, useState } from "react";
import { Button, Col, Divider, Modal, Row, notification } from "antd";
import LeadDetailNewTabs from "./LeadDetailNewTabs";
import History from "./History/History";
import API_SERVICE from "shared/services/api-service";
import activity from "../../../../assets/images/activity.svg";
import { getMaskedMobile, getUserDetails, hasUserRole } from "shared/services/Utility";
import ListLeadDetails from "./LenderDisbursed/ListLeadDetails";
import CloseCase from "./CloseCase/CloseCase";
import "./LeadDetailNew.scss";
import AdditionalField from "shared/components/Lead/AdditionalField/AdditionalField";
import parameters from "shared/parameters";
import RequiredDocuments from "shared/components/Lead/RequiredDocuments/RequiredDocuments";
import ApplicantInformation from "shared/components/Lead/ApplicantInformation/ApplicantInformation";
import EditDetailsNew from "./EditDetailsNew";
import VASOutput from "./VAS/VASOutput";
import whatsappIcon from "../../../../assets/images/whatsappIcon.svg";
import { ReactComponent as IconShare } from "../../../../assets/images/shareIcon.svg";
import {ReactComponent as IconEditBorder} from "../../../../assets/images/edit_border.svg";
import {ReactComponent as IconCopy} from "../../../../assets/images/copy.svg";
import {ReactComponent as Back_Arrow} from "../../../../assets/images/back_arrow.svg";
import {ReactComponent as IconDown} from "../../../../assets/images/down.svg";
import AppLoading from "shared/components/AppLoading/AppLoading";
import { useSelector } from "react-redux";
import { RootState } from "shared/redux/store";
import moment from "moment";
import Customer360 from "./Customer360";
import BankStatementAnalysis from "shared/components/BankStatementAnalysis/BankStatementAnalysis";
import BSAOutputDetails from "shared/components/BankStatementAnalysis/BSAOutputDetails";
import CloseWarningBSA from "shared/components/BankStatementAnalysis/CloseWarningBSA";
import { useHistory, useLocation } from "react-router-dom";
import OIButton from "shared/ComponentsOI/OIButton/OIButton";

export type leadViewTypeScreen =
  | "mainLead"
  | "decisioningOutput"
  | "VasOutput"
  | "LeadDetailNewTabs"
  | "closeCase"
  | "BankStatementAnalysis";

interface ILeadDetail {
  leadData: any;
  getLeadById: any;
  setLeadData: any;
  getRedirectURLLink?: any;
  getCashETriggerSMSLink?: any;
  getDownloadLetterForICICI?: any;
  lenderLoginHandler?: any;
  lenderDecisionHandler?: any;
  lenderNextHandler?: any;
  loading?: any;
  getTaskData?:any
  setGetTaskData?:any
  productWorkflowConfig?:any
  setProductWorkflowConfig?:any
}

const LeadDetailNew: React.FC<ILeadDetail> = (props: ILeadDetail) => {
  const {
    leadData,
    getLeadById,
    setLeadData,
    getRedirectURLLink,
    getCashETriggerSMSLink,
    getDownloadLetterForICICI,
    lenderLoginHandler,
    lenderDecisionHandler,
    lenderNextHandler,
    loading,
    getTaskData,
    setGetTaskData,
    productWorkflowConfig,    
    setProductWorkflowConfig
  } = props;
  const [leadViewType, setLeadViewType] =
    useState<leadViewTypeScreen>("mainLead");
  const [customUI, setCustomUI] = useState(false);
  const [currLenderId, setCurrLenderId] = useState("");
  const [currLoanProductId, setCurrLoanProductId] = useState("");
  const [currLeadId, setCurrLeadId] = useState("");
  const [selectedLander, setSelectedLander] = useState<any>({});
  const [additionalFields, setAdditionalFields] = useState([]);
  const [callbackAdditionalField, setCallbackAdditionalField] = useState(
    {} as any
  );
  const [faircentStatus, setFaircentStatus] = useState("");
  const [taskDetails, setTaskDetails] = useState({
    taskId: "",
    taskDefinitionKey: "",
    taskName: "",
  } as any);
  const [formData, setFormData] = useState({});
  const [isLastTask, setIsLastTask] = useState(false);
  const [selectedLenderList, setSelectedLenderList] = useState([] as any);
  const [loadingUpdate, setLoadingUpdate] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [lenderStatus, setLenderStatus] = useState([] as any);
  const [caseStatus, setCaseStatus] = useState([] as any);
  const [closeWarningBSALocation, setCloseWarningBSAlocation] = useState("");
  const [historyDetails, setHistoryDetails] = useState({} as any);
  const [isDecisioning, setIsDecisioning] = useState(false);
  const [isDecisioningTabAvailable, setIsDecisioningTabAvailable] = useState(false);
  const [isShowBorrowerFullDetails, setIshowBorrowerFullDetails] =
    useState(true);
  const [showBSAOutputDetailsFor, setShowBSAOutputDetailsFor] = useState("");
  const [bsaSelectedTab, setBSASelectedTab] = useState(undefined as "INPUT" | "OUTPUT" | undefined );
  const [callbackReqDoc, setCallbackReqDoc] = useState({});
  const [descisioningDetail, setListDescisioningDetail] = useState([] as any);
  const [showAdditionalFields, setShowAdditionalFields] = useState(false);
  const [showRequirementDocs, setShowRequirementDocs] = useState(false);
  const [isApplicantModal, setIsApplicantModal] = useState(false);
  const [showApplicantInfo, setShowApplicantInfo] = useState(false);
  const [isShowDocument, setIsShowDocument] = useState(false);
  const [isLoginSubmit, setIsLoginSubmit] = useState(false);
  const [isShowConnectorFullDetails, setIshowConnectorFullDetails] =
    useState(true);
  const [isEditDetails, setIsEditDetails] = useState(false);
  const [isModalWhatsappVisible, setIsModalWhatsappVisible] = useState(false);
  const [isSuccessModalVisible, setIsSuccessModalVisible] = useState(false);
  const [showOverview, setShowOverview] = useState(false);
  const [callToActionMore, setCallToActionMore] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const { appColors, isBankAnalysisRequired, isMobile }: any = useSelector((state: RootState) => state.common);
  const { tenantInfo }: any = useSelector((state: RootState) => state.tenant);
  const isCustomer360Enabled = localStorage.getItem("customer360Enabled") == 'true' 
  const [selectedLenderExecutionDataList, setSelectedLenderExecutionDataList] =
      useState([] as any);
  const [decisioningnTabkey, setDecisioningTabkey] =
  useState(leadData?.journeyConfigResponseList?.at(0)?.journeyId);
  const { state, href } : any = useLocation();
  const history = useHistory();
  const btnStylePrimary: any = {"--custColor": appColors?.appPrimaryColor}
  const btnStyleSecondary: any = {"--custColor": appColors?.appSecondaryColor}
  
  useEffect(() => {
    if(state?.isOpenBSAOutput) {
      history.replace(href, {});
      setBSASelectedTab("OUTPUT")
      setLeadViewType("BankStatementAnalysis");
    }
    if(isCustomer360Enabled && window.location.href.includes("cust360")) {
      setCallToActionMore(true);
    }
  }, []);

  useEffect(() => {
    let enumValues = localStorage.getItem("enumValues") as any;
    if (enumValues) {
      enumValues = JSON.parse(enumValues);
      const lenderStatusList = enumValues.find(
        (item) => item.propertyName === "LENDER_STATUS"
      );
      const caseStatusList = enumValues.find(
        (item) => item.propertyName === "CASE_STATUS"
      );
      setLenderStatus(lenderStatusList);
      setCaseStatus(caseStatusList);
    }
    setSelectedLenderList(
      leadData?.caseDetails?.lenderActivityHolder?.lenderActivityDetails
    );
    setHistoryDetails(leadData?.caseDetails?.caseHistoryHolder);
    setIsLoading(false);
  }, [leadData]);

  const genrateBureauScore = (pan?: any) => {
    setIsLoading(true);
    let payload = {
      caseId: leadData?.caseDetails?.caseId,
      panId: pan || leadData?.contactDetails?.pan,
      userId: getUserDetails()?.userId,
    };
    API_SERVICE.genrateBureauScore(payload)
      .then(() => { })
      .catch((e: any) => {
        notification.error({ message: API_SERVICE.handleErrors(e) });
      })
      .finally(() => setIsLoading(false));
  };

  useEffect(() => {
    if (isDecisioning) {
      listDecisioning();
    }
    setIsDecisioning(false);
  }, [isDecisioning]);

  const listDecisioning = () => {
    setIsLoading(true);
    API_SERVICE.listDecisioning(leadData?.caseDetails?.caseId, false)
      .then(({ data }) => {
        setListDescisioningDetail(data?.payload);
      })
      .catch((e: any) => {
        notification.error({ message: API_SERVICE?.handleErrors(e) });
      })
      .finally(() => setIsLoading(false));
  };

  const lenderDisbursedHandler = (values: any) => {
    let lStatusDisbursed = lenderStatus.keyAndDisplayValueList.find(
      (item) => item.key === "DISBURSED"
    );
    let cStatusDisbursed = caseStatus.keyAndDisplayValueList.find(
      (item) => item.key === "DISBURSED"
    );

    let lenderDetails = [] as any;
    values.lenders.map((item) => {
      lenderDetails.push({
        branchName: item.branchName,
        comments: values?.comment ?? "",
        disbursedAmount: item?.disbursedData?.disbursedAmount,
        lenderInfoId: item.lenderInfoId,
        insuranceAmount: item.insuranceAmount,
        hubName: item.hubName,
        lenderActivityId: item.lenderActivityId,
        interestRate: item.interestRate,
        lenderName: item.lenderName,
        rmName: item.rmName,
        sanctionedAmount: item.sanctionedAmount,
        status: (leadData?.loanType === "Credit Card" && lStatusDisbursed.key === "DISBURSED") ? "SANCTIONED" : lStatusDisbursed.key,
        disbursalLenderInfoEntity: item.disbursalLenderInfoEntity,
        payoutDetails: item.payoutDetails,
        payoutInfoDetails: item.payoutInfoDetails,
        payoutInfoEntities: item.payoutInfoEntities,
        subProductDetails:item?.subProductDetails
      });
    });
    const payload = {
      comments: values?.comment ?? "",
      lenderDetails,
    };
    updateCase(payload, cStatusDisbursed, false);
  };

  const getJSONSchema = (jsonSchema: any) => {
    let str = jsonSchema;
    str = str?.replaceAll(
      /https:\/\/[^\/]+-distribution\.oneflotest\.in\/api\/dsa\//g,
      parameters.ApiUrlOne
    );
    str = str.replaceAll(
      /https:\/\/[^\/]+-common\.oneflotest\.in\/api\//g,
      parameters.ApiUrlTwo
    );
    str = str?.replaceAll(
      /https:\/\/[^\/]+-lender\.oneflotest\.in\/api\//g,
      parameters.ApiUrlThree
    );
    const user = localStorage.getItem("user");
    if (user) {
      str = str?.replaceAll("e67fe92d884c2f9460f1744300739f1b", JSON.parse(user as string).apiId);
      str = str?.replaceAll("6e4cf833714519ab7d05d40d37ebb4c1", JSON.parse(user as string).apikey);
      str = str?.replaceAll("16e40d1ae463ca1fb138da75c41f3856", JSON.parse(user as string).apiId);
      str = str?.replaceAll("6743e0681860ce20c8d98b7fcd76bd4b", JSON.parse(user as string).apikey);
      str = str?.replaceAll("ea4e42af01182294135c00273b8dc0ef", JSON.parse(user as string).apiId);
      str = str?.replaceAll("a5d83196d537a0a0adb594e804ab7018", JSON.parse(user as string).apikey);
    }
    return JSON.parse(str);
  };

  const updateCase = (payload, status, isCallStartProcess: boolean) => {
    setIsLoading(true);
    setLoadingUpdate(false);
    
    return API_SERVICE.updateCase(
      leadData?.caseDetails?.caseId,
      status.key,
      payload,
      leadData?.loanProductId
    )
      .then(({ data }) => {
        if (data) {
          getLeadById();
          notification.success({ message: data.message });
          const findCurrentLender =
            data?.payload?.caseDetails?.lenderActivityHolder?.lenderActivityDetails?.find(
              (item: any) =>
                item?.lenderInfoId ==
                payload?.lenderDetails?.at(0)?.lenderInfoId
            );
          if (
            findCurrentLender?.submissionType == "API" &&
            isCallStartProcess
          ) {
            getLenderAdditonalField(findCurrentLender);
          } else if ((status?.key == "LENDER_SELECTION") || (status?.key == "INSURER_POLICY_SELECTION")) {
            const lenderDetails = payload?.lenderDetails?.map((item: any) => {
              return { ...item, status: "LOGGED", lenderActivityId:findCurrentLender?.lenderActivityId,subProductDetails:null };
            });
            const payload1 = {
              comments: null,
              lenderDetails: lenderDetails,
            };
            setIsLoading(true);
            setLoadingUpdate(false);
            setTimeout(() => {
              updateCase(payload1, { key: tenantInfo?.businessProductType === "INSURANCE" ? "POLICY_LOGGED" : "LOGGED" }, false);
            }, 1000);
          } else {
            setIsLoading(false);
          }
          if (status?.key == "LOGGED" || status?.key == "POLICY_LOGGED") {
            setIsLoginSubmit(true);
          }
        }
      })
      .catch((e: any) => {
        notification.error({ message: API_SERVICE.handleErrors(e) });
        setIsLoading(false);
      })
      .finally(() => {
        setLoadingUpdate(false);
      });
  };

  const getLenderAdditonalField = (currentLender: any) => {
    setIsLoading(true);
    setCurrLenderId(currentLender?.lenderInfoId);
    API_SERVICE.getLenderAdditonalField(
      currentLender?.lenderInfoId,
      leadData?.caseDetails?.caseId,
      leadData?.loanProductId
    )
      .then(({ data }) => {
        if (data?.payload?.workflowType === "FLOWABLE") {
          setAdditionalFields([]);
          setSelectedLander(currentLender);
          setShowAdditionalFields(true);
          // setIsLastTask();
          setCustomUI(data?.payload?.taskDetail?.customUI ?? false);
          console.log(data?.payload?.taskDetail?.customUI);
          setIsLastTask(data?.payload?.taskDetail?.lastStep);
          setFormData(
            getJSONSchema(
              data?.payload?.taskDetail?.jsonSchema
                .replaceAll("console.log(value);", "")
                .replaceAll(`"required": true`, `"required": false`)
            )
          );
          setTaskDetails({
            taskName: data?.payload?.taskDetail?.taskName,
            taskDefinitionKey: data?.payload?.taskDetail?.taskDefinitionKey,
            taskId: data?.payload?.taskDetail?.taskId,
            responseToRender: data?.payload?.taskDetail?.responseToRender,
          });
        } else {
          if ((data?.payload?.lenderFieldValues?.length ?? 0) > 0) {
            setAdditionalFields(data?.payload?.lenderFieldValues);
            // setAdditionalFields(dummyAdditionalFieldData);
            setSelectedLander(currentLender);
            setShowAdditionalFields(true);
            // setShowRequirementDocs(true);
          } else {
            // setCheckedLeader(true, currentLender.lenderInfoId);
          }
        }
      })
      .catch((e: any) => {
        if (currentLender?.lenderName?.toLowerCase()?.includes("kreditbee")) {
          // setCheckedLeader(true, currentLender.lenderInfoId);
          notification.success({ message: "Lead updated successfully" });
          // skippedLoginStatus();
        } else {
          notification.error({ message: API_SERVICE.handleErrors(e) });
          // setCheckedLeader(true, currentLender.lenderInfoId);
        }
      })
      .finally(() => setIsLoading(false));
  };

  const handleDocumentScreen = () => {
    setLeadViewType("LeadDetailNewTabs");
    setIsShowDocument(true);
  };

  const handleDecisionOutPutScreen = () => {
    setLeadViewType("decisioningOutput");
    setIsShowDocument(false);
  };

  const handleVasOutPutScreen = () => {
    setLeadViewType("VasOutput");
    setIsShowDocument(false);
  };

  const handleCloseCaseScreen = () => {
    setLeadViewType("closeCase");
    setIsShowDocument(false);
  };

  const getShareLinkId = (item: any) => {
    API_SERVICE.getShareLinkId(item?.caseDetails?.caseId)
      .then(({ data }) => {
        navigator.clipboard.writeText(data?.payload);
      })
      .catch((error) => {
        notification.error({ message: error });
      })
      .finally(() => { });
  };

  const renderLeadViewTypeScreen = () => {
    if (leadViewType == "BankStatementAnalysis") {
      return (
        <div style={{padding:"10px", paddingTop:'0px'}}>
          <BankStatementAnalysis 
            leadData={leadData}
            setShowBSAOutputDetailsFor={setShowBSAOutputDetailsFor}
            bsaSelectedTab={bsaSelectedTab}
            actionBack={() => {
              setLeadViewType("mainLead")
              setBSASelectedTab("INPUT")
            }}
          />
        </div>
      );
    } else if (leadViewType == "decisioningOutput") {
      return (
        <>
          <ListLeadDetails
            leadData={leadData}
            setLeadViewType={setLeadViewType} 
            descisioningDetail={descisioningDetail}
            setListDescisioningDetail={setListDescisioningDetail}
            selectedLenderExecutionDataList={selectedLenderExecutionDataList}
            setSelectedLenderExecutionDataList={setSelectedLenderExecutionDataList}
            decisioningnTabkey = {decisioningnTabkey}
            setDecisioningTabkey = {setDecisioningTabkey}
          />
          <VASOutput 
            setLeadViewType={leadViewType} 
            leadData={leadData}
            leadViewType={leadViewType}
            selectedLenderExecutionDataList={selectedLenderExecutionDataList}
            descisioningDetail = {descisioningDetail}
            setListDescisioningDetail = {setListDescisioningDetail}
            decisioningnTabkey = {decisioningnTabkey}
            setDecisioningTabkey = {setDecisioningTabkey}
            productWorkflowConfig={productWorkflowConfig}
          />
        </>
      );
    } else if (leadViewType == "closeCase") {
      return (
        <CloseCase leadData={leadData} setLeadViewType={setLeadViewType} />
      );
    } else if (leadViewType == "VasOutput") {
      return (
        <VASOutput 
        setLeadViewType={setLeadViewType} 
        leadData={leadData} 
        leadViewType={leadViewType}
        selectedLenderExecutionDataList={selectedLenderExecutionDataList}
        descisioningDetail = {descisioningDetail}
        setListDescisioningDetail = {setListDescisioningDetail}
        decisioningnTabkey = {decisioningnTabkey}
        setDecisioningTabkey = {setDecisioningTabkey}
        productWorkflowConfig={productWorkflowConfig}
      />
      );
    } else {
      return (
        <LeadDetailNewTabs
          leadData={leadData}
          selectedLenderList={selectedLenderList}
          lenderDisbursedHandler={lenderDisbursedHandler}
          getRedirectURLLink={getRedirectURLLink}
          getCashETriggerSMSLink={getCashETriggerSMSLink}
          getDownloadLetterForICICI={getDownloadLetterForICICI}
          loadingUpdate={loadingUpdate}
          updateCase={updateCase}
          getJSONSchema={getJSONSchema}
          callbackReqDoc={callbackReqDoc}
          setCallbackReqDoc={setCallbackReqDoc}
          callbackAdditionalField={callbackAdditionalField}
          setShowRequirementDocs={setShowRequirementDocs}
          setSelectedLander={setSelectedLander}
          selectedLander={selectedLander}
          setAdditionalFields={setAdditionalFields}
          setCurrLenderId={setCurrLenderId}
          setCurrLeadId={setCurrLeadId}
          setShowAdditionalFields={setShowAdditionalFields}
          genrateBureauScore={genrateBureauScore}
          setShowApplicantInfo={setShowApplicantInfo}
          setIsApplicantModal={setIsApplicantModal}
          isApplicantModal={isApplicantModal}
          lenderDecisionHandler={lenderDecisionHandler}
          isShowDocument={isShowDocument}
          setIsShowDocument={setIsShowDocument}
          getLeadById={getLeadById}
          setIsLoginSubmit={setIsLoginSubmit}
          isLoginSubmit={isLoginSubmit}
          setLeadViewType={setLeadViewType}
          getLenderAdditonalField={getLenderAdditonalField}
          setIsLoading={setIsLoading}
          isLoading={isLoading}
          lenderNextHandler={lenderNextHandler}
          loading={loading}
          setIsDecisioningTabAvailable={setIsDecisioningTabAvailable}
          isDecisioningTabAvailable={isDecisioningTabAvailable}
          getTaskData = {getTaskData}
          setGetTaskData = {setGetTaskData}
          productWorkflowConfig={productWorkflowConfig}
          setProductWorkflowConfig={setProductWorkflowConfig}
        />
      );
    }
  };

  const renderAdditionalField = () => (
    <AdditionalField
      setCustomUI={setCustomUI}
      setLeadData={setLeadData}
      currLenderId={currLenderId}
      currLoanProductId={currLoanProductId}
      currLeadId={leadData?.caseDetails?.caseId}
      customUI={customUI}
      selectedLander={selectedLander}
      leadData={leadData}
      additionalFields={additionalFields ? additionalFields : []}
      setShowAdditionalFields={setShowAdditionalFields}
      callbackAdditionalField={setCallbackAdditionalField}
      setFaircentStatus={setFaircentStatus}
      taskDetails={taskDetails}
      formData={formData ?? {}}
      setIsLastTask={setIsLastTask}
      isLastTask={isLastTask}
      setAdditionalFields={setAdditionalFields}
      setTaskDetails={setTaskDetails}
      getLeadById={getLeadById}
      setCallbackReqDoc={setCallbackReqDoc}
      callBackRejected={(callBackData) => {
        getLeadById();
        const status = callBackData?.status ?? "";
        if (status.length > 0 && ["rejected"].includes(status.toLowerCase())) {
          setTimeout(() => {
            setShowRequirementDocs(false);
            // setLanderDecisionActive(true);
            // setLoading(false);
            notification.error({ message: callBackData?.Message });
          });
        }
      }}
      callBack={() => {
        getLeadById();
      }}
      skippedLoginStatus={() => { }}
    />
  );

  const renderRequireDocuments = () => (
    <div className="content-box">
      <RequiredDocuments
        selectedLander={selectedLander}
        leadData={leadData}
        setShowRequirementDocs={setShowRequirementDocs}
        callBackDoc={(data) => {
          console.log("callBackDoc ---- ", data);
          setCallbackReqDoc(data);
          if (selectedLander?.lenderName?.toLowerCase()?.includes("fibe")) {
            getLeadById();
            // const status =
            //   (callbackAdditionalField as any)?.earlySalaryResponse?.status ?? "";
            // if (status.length > 0 && !["Suspended", "Success"].includes(status)) {
            //   setTimeout(() => {
            //     // setLoading(false);
            //   }, 1000);
            // }
          } else {
            const lender =
              leadData?.caseDetails?.lenderActivityHolder?.lenderActivityDetails?.find(
                (lItem) => lItem.lenderInfoId === data.lenderInfoId
              );
            if (lender && lender?.status === "LOGGED") {
              // skippedLoginStatus();
            } else {
              lenderLoginHandler({
                comment: null,
                assignedLenderFiltered: [selectedLander],
              });
            }
          }
        }}
      />
    </div>
  );

  const renderKeyValue = (title: string, value: string = "", isHideBottom: boolean = false, isValueBg: boolean = false) => {
    return (
      <div className={`keyValue ${isHideBottom ? " hide-bottom" : ""}`}>
        <span className="item">{title}</span>
        <span className={`item span-value ${isValueBg ? " bg" : ""}`}>{value}</span>
      </div>
    )
  }

  const renderCustomerDetials = () => {
    const customer360 = leadData?.dsaCaseAdditionalAttributes?.customer360 ?? {};
    const preQualified = customer360?.preQualified ?? {};
    // const isPreQualified = (Object.keys(preQualified)?.length ?? 0) > 0
    const isPreQualified = leadData?.showPAPQSpecificSection;
    const userRolePermission = hasUserRole();
    const isMasked = userRolePermission["MaskMobileNumber"];
    return(
    <Col xs={24} lg={6} span={6} className="col-border-right-3">
      <div style={{ padding: "8px" }}>
        <div className="details-title">
          <span style={{ fontSize: "16px" }}>Customer Details</span>
          <div>
            <Button
              size="small"
              className="custome-btn-icon-secondary"
              style={{ '--bgColor': appColors?.appSecondaryColor ?? "" } as any}
              type="text"
              // hidden={selectedPreCase === "LEAD" && activeKey === "1"}
              onClick={() => getShareLinkId(leadData)}
              icon={<IconShare width={24} height={24} />
              }
            />
            <Button 
            size="small"
            hidden={!leadData?.isWhatsAppEnabled}
            className="custome-btn-icon-secondary"
            type="text"
            onClick={() => handleClick()}
            icon={
              <img
                src={whatsappIcon}
                alt=""
                width={24}
                height={24}
                style={{ marginTop: "-4px" }}
              />
            }
          />
          </div>
        </div>
        <div className="details-box">
          {renderKeyValue("Name", leadData?.contactDetails?.firstName)}
          {renderKeyValue("Mobile No", getMaskedMobile(isMasked, leadData?.contactDetails?.mobileNumber))}
          {renderKeyValue("Applicant Type", leadData?.applicationType)}
          {renderKeyValue(leadData?.applicationTypeKey === "BUSINESS" ? "Business Type" : "Individual Type", leadData?.applicationSubType)}
          {renderKeyValue("Loan Type", leadData?.loanType)}
          <div className={`keyValue hide-bottom`}>
            <span className="item">{"Case ID"}</span>
            <div style={{display:'flex', alignItems:'center'}}>
            <span className={`item span-value`}>{leadData?.caseDetails?.caseId}</span>
            <Button
              style={{border:'none'}}
              size="small"
              onClick={() => navigator.clipboard.writeText(leadData?.caseDetails?.caseId ?? "")}
              icon={<IconCopy width={14} />}
            />
            </div>
          </div>
        </div>
      </div>
      <div style={{ padding: "8px" }}>
        <div className="details-title">
          <span style={{ fontSize: "16px" }}>Connector Details</span>
          <Button
            size="small"
            type="text"
            onClick={() => {
              if(isBankAnalysisRequired) {
                setCloseWarningBSAlocation("EditConnectorDetails");
              } else {
                setIsEditDetails(true)
              }
            }}
            icon={<IconEditBorder />}
          />
        </div>
        <div className="details-box">
          {isShowConnectorFullDetails && (
            <>
              {renderKeyValue("Connector Name", leadData?.sourceOfCase == "CONNECTOR" ? leadData?.caseDetails?.connectorDetails?.userDetails?.fullName : "")}
              {/* {renderKeyValue("Tentative Payout %", leadData?.caseDetails?.loanDetails?.expectedInterestRate ?? 0)} */}
              {renderKeyValue("Assign To", leadData?.caseDetails?.assignedToUserDetails?.fullName)}
              {renderKeyValue("Assign To Back Office", leadData?.caseDetails?.backOfficeUserDetails?.fullName, true)}
            </>
          )}
        </div>
      </div>
      <div style={{ padding: "8px" }}>
        <div className="details-title">
          <span style={{ fontSize: "16px" }}>Call to Action Details</span>
          <OIButton
            label="View More"
            style={{...btnStylePrimary, width:"72px", minWidth:"72px", height:"24px"}}
            className="btn-view-more"
            size="small"
            onClick={() => {
              if(isCustomer360Enabled) {
                if(isBankAnalysisRequired) {
                  setCloseWarningBSAlocation("ViewMoreCallToActionDetails");
                } else {
                  setCallToActionMore(true)
                }
              } else {
                notification.error({message:"The Customer 360 feature is currently disabled. Contact the administration team to enable it"})
              }
            }}
          />
        </div>
        <div className="details-box">
          {isCustomer360Enabled && (
            <>
              <div className={`keyValue`}>
                <span style={{ fontSize: '14px' }}>{"Call to Action"}</span>
              </div><div className={`keyValue`}>
              <span style={{ fontSize: '20px', color: 'black', marginBottom: '10px' }}>
                    {/* {isPreQualified ? "Pre Qualified" : "Balance Top Up"} */}
                {isPreQualified  ? "Pre Qualified ": customer360.callToAction}
              </span>
              </div>
            </>
          )}
          {isCustomer360Enabled ? (
            <>
              {isPreQualified ? (
                <>
                  {renderKeyValue("Lender Name", preQualified?.preQualifiedLenderName, false, true)}
                  {renderKeyValue("Amount", preQualified?.preQualifiedAmount, false, true)}
                  {renderKeyValue("ROI", (preQualified?.preQualifiedRateOfInterest)?`${preQualified?.preQualifiedRateOfInterest}%`:"", false, true)}
                  {renderKeyValue("Tenure", (preQualified?.preQualifiedTenure)?`${preQualified?.preQualifiedTenure} Years`:"", false, true)}
                  {renderKeyValue("Validity", (preQualified?.preQualifiedValidity)? moment(preQualified?.preQualifiedValidity).locale("en").format("MMM DD, YYYY"):"", true, true)}
                </>
              ): 
                <>
                  {renderKeyValue("Product Type", customer360?.loanType, false, true)}
                  {renderKeyValue("Offer Amount", customer360?.loanAmount, true, true)}
                </>
              }  
            </>
          ): 
            <>
              {isPreQualified ? (
                  <>
                    {renderKeyValue("Lender Name", "", false, true)}
                    {renderKeyValue("Amount", "", false, true)}
                    {renderKeyValue("ROI", "", false, true)}
                    {renderKeyValue("Tenure","", false, true)}
                    {renderKeyValue("Validity", "", true, true)}
                  </>
                ): 
                <>
                  {renderKeyValue("Product Type", "", false, true)}
                  {renderKeyValue("Offer Amount", "", true, true)}
                </>
              }  
            </>
          }          
        </div>
      </div>
    </Col>
  )};

  const handleClick = () => {


    API_SERVICE.getWhatsAppDocumentValidate(leadData.caseDetails.caseId)
      .then(({ data }) => {

        if (data.payload.validToSend) {
          setIsModalWhatsappVisible(true);
        }
        else {
          // setIsModalWhatsappVisible(false)
          // notification.error({ message: data.payload.message })
          setIsModalWhatsappVisible(false);
          setSuccessMessage(data.payload.message);
          setIsSuccessModalVisible(true);

        }
      })
      .catch((e: any) => {
        notification.error({ message: API_SERVICE.handleErrors(e) });
      });
  }

  const handleModalOk = () => {
    setIsModalWhatsappVisible(false);
    API_SERVICE.sendWhatsAppMessage(leadData?.caseDetails?.caseId)
      .then(({ data }) => {
        setIsModalWhatsappVisible(false);
        if (data.payload) {
          notification.success({ message: data.payload })
        }
      })
      .catch((e: any) => {
        notification.error({ message: API_SERVICE.handleErrors(e) });
      });
  };
  const handleModalCancel = () => {
    setIsModalWhatsappVisible(false);
  };
  const handleModalmessage = () => {
    setIsSuccessModalVisible(false);
  }
  const whatsapp = () => {
    return (
      <Modal
        centered
        width={450}
        visible={isModalWhatsappVisible}
        footer={null}
        closable={false}
      >
        <div
          style={{
            paddingBottom: "40px",
            paddingTop: "40px",
            paddingLeft: "15px",
            paddingRight: "15px",
          }}
        >
          <p
            style={{
              textAlign: "center",
              marginTop: "10px",
              marginBottom: "35px",
              marginLeft: "5px",
              fontSize: "medium",
            }}
          >
            Is {leadData?.contactDetails?.mobileNumber} the valid contact number? <br />
            If not, please update lead details.
          </p>
          <div
            style={{ display: "flex", gap: "10px", justifyContent: "center" }}
          >
            <OIButton
              label="Confirm"
              type="primary"
              style={btnStylePrimary}
              onClick={handleModalOk}
            />
            <OIButton
              label="Back"
              style={btnStyleSecondary}
              onClick={handleModalCancel}
            />
          </div>
        </div>
      </Modal>
    );
  };


  const message = () => {
    return (<Modal
      centered
      width={450}
      visible={isSuccessModalVisible}

      footer={null}
      closable={false}
    > <p
      style={{
        textAlign: "center",
        marginTop: "30px",
        marginBottom: "15px",
        marginLeft: "5px",
        fontSize: "medium",
      }}
    >{successMessage}
      </p>
      <Button
        type="default"
        className="dynamic-btn-default"
        style={{'--borderColor': appColors?.appSecondaryColor ?? "",width: "155px", height: "40px", borderRadius: "8px", margin: "20px",marginLeft: "110px"}as any}
        onClick={handleModalmessage}
      >
        OK
      </Button>

    </Modal>
    )
  }

  const renderCallToAction = () => {
    const customer360 = leadData?.dsaCaseAdditionalAttributes?.customer360 ?? {};
    return(
      <Col xs={24} lg={14} span={14} className="col-border-right-3">
      <div style={{display:'flex', justifyContent:'right', padding:"12px"}}>
        <Button
          className="back-icon-btn"
          style={{width:"80px", paddingLeft:"0px", paddingRight:"6px"}}
          onClick={() => setCallToActionMore(false)}
        >
          <Back_Arrow /> Back
        </Button>
      </div>
      <Customer360
        caseId={leadData?.caseDetails?.caseId}
        customer360Data={customer360}
        isPAPQ={leadData?.showPAPQSpecificSection}
         />
    </Col>
    )
    
  };


  const renderTabsView = () => (
    <Col xs={24} lg={14} span={14} className="col-border-right-3">
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          // overflow: "auto",
        }}
      >
        <div style={{ width: "100%" }}>{renderLeadViewTypeScreen()}</div>
      </div>
      {leadViewType != "BankStatementAnalysis" &&
        <History historyDetails={historyDetails} />
      }
    </Col>
  );

  const renderBSAOutputDetails = () => {
    return (
      <Col xs={24} lg={20} span={20} className="col-border-right-3" style={{paddingInline:"10px"}}>
        <BSAOutputDetails 
          showBSAOutputDetailsFor={showBSAOutputDetailsFor}
          setShowBSAOutputDetailsFor={setShowBSAOutputDetailsFor} 
          setBSASelectedTab={setBSASelectedTab}
        />
      </Col>
    )
  }

  const renderActivity = () => (
    <Col xs={24} lg={4} span={4}>
      <div style={{ display: "flex", justifyContent: "center" }}>
        <div>
          <h5 style={{ marginTop: "15px" }}>
            <span>
              <img src={activity} alt="" style={{ marginTop: "-5px" }} />
            </span>{" "}
            Activity
          </h5>
        </div>
      </div>
      <div style={{ marginBlock: "15px" }}>
        <Button
          type="text"
          className="activity-btn"
          onClick={() => {
            if(isBankAnalysisRequired) {
              setCloseWarningBSAlocation("LeadDetailNewTabs");
            } else {
              handleDocumentScreen();
            }
          }}
          style={{ background: "none" }}
        >
          Documents
        </Button>
        <Divider style={{ marginTop: "6px", marginBottom: "8px" }} />
        <Button
          type="text"
          className="activity-btn"
          onClick={() => {
            if(isBankAnalysisRequired) {
              setCloseWarningBSAlocation("closeCase");
            } else {
              handleCloseCaseScreen();
            }
          }}
          style={{ background: "none" }}
        >
          Close Case
        </Button>
        <Divider style={{ marginTop: "6px", marginBottom: "8px" }} />
        {isDecisioningTabAvailable &&
        <>
        <Button
          type="text"
          className="activity-btn"
          onClick={() => {
            if(isBankAnalysisRequired) {
              setCloseWarningBSAlocation("decisioningOutput");
            } else {
              handleDecisionOutPutScreen()
            }
          }}
          style={{ background: "none" }}
        >
          Decisioning
        </Button>
        <Divider style={{ marginTop: "6px", marginBottom: "8px" }} />
        </>
        }
        {tenantInfo?.businessProductType !== "INSURANCE" &&
        <>
        <Button
          type="text"
          className="activity-btn"
          onClick={() => {
            if(isBankAnalysisRequired) {
              setCloseWarningBSAlocation("VasOutput");
            } else {
              handleVasOutPutScreen()
            }
          }}
          style={{ background: "none" }}
        >
          VAS Output
        </Button>
        <Divider style={{ marginTop: "6px", marginBottom: "8px" }} />
        </>
        }
        <Button
          type="text"
          className="activity-btn"
          onClick={()=> setLeadViewType("BankStatementAnalysis")}
          style={{ background: "none" }}
        >
          Bank Statement Analysis
        </Button>
        <Divider style={{ marginTop: "6px", marginBottom: "8px" }} />
        <Button
          type="text"
          hidden={!leadData?.isWhatsAppEnabled}
          className="activity-btn"
          onClick={() => {
            handleClick();
          }}
          style={{ background: "none" }}
          icon={
            <img
              src={whatsappIcon}
              alt=""
              width={18}
              height={24}
              style={{ marginTop: "-2px", marginRight: "2px" }}
            />}
        > Share on Whatsapp
        </Button>
      </div>
    </Col>
  );

  const renderApplicantInfo = () => (
    <ApplicantInformation
      isGetBureauScore={false}
      setShowApplicantInfo={setShowApplicantInfo}
      setIsApplicantModal={setIsApplicantModal}
      leadData={leadData}
      genrateBureauScore={genrateBureauScore}
      getLeadById={getLeadById}
    />
  );

  const renderCaseDetials = () => (
    <div style={{ marginTop: "3px" }}>
      <div className="manage-form">
        {isEditDetails ? (
          <>
            <EditDetailsNew
              leadData={leadData}
              setIsEditDetails={setIsEditDetails}
              isEditDetails={isEditDetails}
              getLeadById={getLeadById}
              setLeadData={setLeadData}
            />
          </>
        ) : (
          <>
            <Row style={{ background: "#fff" }}>
              {(showBSAOutputDetailsFor?.length ?? 0) > 0
                ? renderBSAOutputDetails()
                : <>
                    {isMobile 
                      ? <div className="overview-view">
                          <div 
                            className="overview-title" 
                            id={`${showOverview}`}
                            style={{width: "100%", paddingBlock: "10px", paddingInline: "20px"}} 
                            onClick={() => setShowOverview(!showOverview)}
                            >
                            <span style={{ fontSize: "16px" }}>Overview</span>
                            <IconDown style={{width: "18px", height: "18px"}}/>
                          </div>
                          {showOverview && renderCustomerDetials()}
                        </div>
                      : renderCustomerDetials()
                    }
                    {callToActionMore ? renderCallToAction() : renderTabsView()}
                  </>
              }
              {renderActivity()}
            </Row>
          </>
        )}
      </div>
    </div>
  );

  return (
    <>
      {closeWarningBSALocation?.length > 0 && (
        <CloseWarningBSA
          closeWarningBSALocation={closeWarningBSALocation}
          setCloseWarningBSAlocation={setCloseWarningBSAlocation}
          callBack={(newlocation) => {
            if(newlocation == "LeadDetailNewTabs") {
              handleDocumentScreen();
            } else if(newlocation == "closeCase") {
              handleCloseCaseScreen();
            } else if(newlocation == "decisioningOutput") {
              handleDecisionOutPutScreen();
            } else if(newlocation == "VasOutput") {
              handleVasOutPutScreen();
            } else if(newlocation == "EditConnectorDetails") {
              setIsEditDetails(true)
            } else if(newlocation == "ViewMoreCallToActionDetails") {
              setCallToActionMore(true)
            }
          }}
        />
      )}
      {whatsapp()}
      {message()}
      {showAdditionalFields
        ? renderAdditionalField()
        : showRequirementDocs
          ? renderRequireDocuments()
          : showApplicantInfo
            ? renderApplicantInfo()
            : renderCaseDetials()}
      {isLoading && <AppLoading />}
    </>
  );
};
export default LeadDetailNew;
